(() => {
  const selector = "[data-can-hover-sprite]";

  function setupSprite(root) {
    if (root.dataset.spriteInitialized === "true") return;
    root.dataset.spriteInitialized = "true";

    const spriteUrl = root.dataset.spriteUrl;
    const canvas = root.querySelector(".can-hover-sprite__canvas");
    const hoverTarget = root.closest(".aw-product-card") || root;
    if (!spriteUrl || !canvas) return;

    const context = canvas.getContext("2d");
    const frameWidth = Number(root.dataset.frameWidth);
    const frameHeight = Number(root.dataset.frameHeight);
    const frameCount = Number(root.dataset.frameCount);
    const columns = Number(root.dataset.columns);
    const fps = Number(root.dataset.fps) || 6;
    const autoplay = root.dataset.autoplay === "true";
    const canHover = window.matchMedia("(hover: hover)").matches;
    const autoplayOnViewport =
      !canHover &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const loopsAnimation = autoplay || autoplayOnViewport;
    const image = new Image();
    let frame = 0;
    let animationId = 0;
    let active = false;
    let lastFrameTime = 0;
    let imageReady = false;
    let isInViewport = false;

    if (!context || !frameWidth || !frameHeight || !frameCount || !columns)
      return;

    const drawFrame = (index) => {
      if (!imageReady) return;
      context.clearRect(0, 0, frameWidth, frameHeight);
      context.drawImage(
        image,
        (index % columns) * frameWidth,
        Math.floor(index / columns) * frameHeight,
        frameWidth,
        frameHeight,
        0,
        0,
        frameWidth,
        frameHeight,
      );
    };

    const render = (timestamp) => {
      if (!active) return;

      if (timestamp - lastFrameTime >= 1000 / fps) {
        lastFrameTime = timestamp;
        drawFrame(frame);
        frame += 1;
      }

      if (frame >= frameCount) {
        if (loopsAnimation) {
          frame = 0;
          lastFrameTime = timestamp;
          drawFrame(frame);
        } else {
          active = false;
          return;
        }
      }

      animationId = window.requestAnimationFrame(render);
    };

    const start = () => {
      if (!imageReady) return;
      window.cancelAnimationFrame(animationId);
      active = true;
      frame = 0;
      lastFrameTime = 0;
      drawFrame(frame);
      animationId = window.requestAnimationFrame(render);
    };

    const stopAndReset = () => {
      active = false;
      window.cancelAnimationFrame(animationId);
      frame = 0;
      lastFrameTime = 0;
      if (image.complete) drawFrame(0);
    };

    if (autoplayOnViewport && "IntersectionObserver" in window) {
      const visibilityTarget =
        hoverTarget.querySelector(".aw-product-card__image") || hoverTarget;
      const visibilityThreshold = 0.8;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isInViewport =
              entry.isIntersecting &&
              entry.intersectionRatio >= visibilityThreshold;
            root.dataset.inViewport = String(isInViewport);
            hoverTarget.dataset.inViewport = String(isInViewport);

            if (isInViewport) start();
            else stopAndReset();
          });
        },
        { threshold: visibilityThreshold },
      );
      observer.observe(visibilityTarget);
    }

    image.addEventListener("load", () => {
      imageReady = true;
      drawFrame(0);
      root.dataset.ready = "true";
      hoverTarget.dataset.spriteReady = "true";

      if (
        autoplay ||
        isInViewport ||
        (canHover && hoverTarget.matches(":hover"))
      )
        start();
    });
    image.addEventListener("error", () => {
      root.dataset.spriteError = "true";
      console.error("Unable to load can hover sprite:", spriteUrl);
    });
    image.src = spriteUrl;

    if (!autoplay && canHover) {
      hoverTarget.addEventListener("mouseenter", start);
      hoverTarget.addEventListener("mouseleave", stopAndReset);
    }

    if (!autoplay) {
      if (!canHover) {
        hoverTarget.addEventListener("pointerdown", (event) => {
          if (event.pointerType === "touch") start();
        });
      }

      hoverTarget.addEventListener("focusin", () => {
        if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches)
          start();
      });
      hoverTarget.addEventListener("focusout", () => {
        if (!isInViewport) stopAndReset();
      });
    }
  }

  const initialize = (scope = document) => {
    if (scope.matches?.(selector)) setupSprite(scope);
    scope.querySelectorAll(selector).forEach(setupSprite);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialize());
  } else {
    initialize();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initialize(event.target);
  });

  // AJAX product navigation replaces .aw-flavor-media wholesale, so the sprite
  // in the incoming markup arrives uninitialised. setupSprite's guard makes the
  // rescan a no-op for the sprites that are already running.
  document.addEventListener("aw:product:changed", () => initialize());
})();
